import { h } from 'preact'
import { useState } from 'preact/hooks'
import PNFO from 'jlinc-shared/PNFO'
import { setPageTitle } from 'lib/Page'

import ContentBox from 'components/ContentBox'
import HeaderedContentBox from 'components/HeaderedContentBox'
import SearchInput from 'components/SearchInput'

import AllOrganizationsList from 'components/AllOrganizationsList'
import './index.sass'


export default function SuperAdminPage() {

  const [searchQuery, setSearchQuery] = useState('')

  setPageTitle(`${PNFO.plural} - All`)

  return (
    <div className={`HubsPage`}>

      <SearchInput
        value={searchQuery}
        onInput={setSearchQuery}
        placeholder={`Search all ${PNFO.plural}…`}
        className="HubsPage-search"

      />
      <ContentBox className="HubsPage-Nav">
        <HeaderedContentBox header={`All ${PNFO.plural}`} icon="circle-thin">
          <AllOrganizationsList searchQuery={searchQuery} showMembershipPills />
        </HeaderedContentBox>

      </ContentBox>
    </div >
  )
}
